<template>
  <v-dialog
    lazy
    :persistent="persistent"
    :value="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="$store.state.common.largeDialogWidth"
    @input="(val) => $emit('update:show', val)"
  >
    <v-card>
      <v-card-title class="pb-0">
        <v-layout align-center>
          <slot name="title" />
          <v-btn
            class="ml-auto mr-0 my-0"
            flat
            icon
            :disabled="loading"
            :title="$t('cancel')"
            @click="reject()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <slot name="content" />
      </v-card-text>
      <v-card-actions>
        <slot name="actions">
          <v-layout justify-center>
            <btn-ok
              round
              :loading="loading"
              @click="confirm()"
            />
          </v-layout>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnOk from '@/components/ButtonOk';

export default {
  components: {
    BtnOk,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    closeOnConfirm: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    reject() {
      this.$emit('rejected');
      this.$emit('update:show', false);
    },
    confirm() {
      this.$emit('confirmed');
      if (this.closeOnConfirm) {
        this.$emit('update:show', false);
      }
    },
  },
};
</script>

<style scoped>
.anchor {
  color: var(--msr-color-primary);
  text-decoration: underline;
  pointer-events: initial;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/GenericConfirmationDialog.vue